<template>
  <div id="content">
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Přidat balíček</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-show="$_createActionAllowedAllOrOwnAndGlobal">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                >
                </operator-select>
              </div>
              <div class="field_right">
                <select-box
                    v-if="!isGlobalPackage || !$_loggedUser_action_allowed('businessModels')"
                    id="packagebusinessmodel"
                    :options="allBusinessModelsWithUndefinedOption"
                    v-model="businessModelSingle"
                    :required="true"
                    :disabled="true"
                    ref="packagebusinessmodelref"
                >
                  <translate class="translate">Business model</translate>
                </select-box>
                <select-box-multi
                    v-if="isGlobalPackage && $_loggedUser_action_allowed('businessModels')"
                    id="packagebusinessmodel"
                    :options="multiBusinessModelOptions"
                    v-model="entity.id_business_models"
                    :required="true"
                    :disabled="!$_loggedUser_action_allowed('businessModels', 'read', 'ALL')"
                    ref="packagebusinessmodelref"
                >
                  <translate class="translate">Business model</translate>
                </select-box-multi>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Základní údaje</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <text-input id="package-name"
                            v-model="entity.name"
                            :required="true"
                            ref="packagenameref"
                >
                  <translate class="translate">Název balíčku</translate>
                </text-input>
              </div>
              <div class="field_right">
                <text-input
                    id="package-price"
                    v-model="entity.price"
                >
                  <translate class="translate">Cena (Kč)</translate>
                </text-input>
              </div>
              <div class="field_left">
                <select-box
                    id="package_type"
                    :required="true"
                    v-model="packageTypeComputed"
                    :options="packageTypeOptions"
                    ref="packagetyperef"
                >
                  <translate class="translate">Typ balíčku</translate>
                </select-box>
              </div>
              <div class="field_right checkboxes" v-show="entity.type === 'basic'">
                <filter-checkbox
                    id="combinationwithbasic"
                    name="combinationwithbasic"
                    :val="entity.combination_with_basic"
                    v-model="entity.combination_with_basic"
                >
                  <translate class="translate">Kombinace se základními balíčky</translate>
                </filter-checkbox>
                <filter-checkbox
                    id="combinationwiththematic"
                    name="combinationwiththematic"
                    :val="entity.combination_with_thematic"
                    v-model="entity.combination_with_thematic"
                >
                  <translate class="translate">Kombinace s tématickými balíčky</translate>
                </filter-checkbox>
              </div>
              <div class="field_left">
                <filter-checkbox
                    id="includeinreport"
                    name="includeinreport"
                    :val="entity.include_in_report"
                    v-model="entity.include_in_report"
                ><translate class="translate">Zahrnovat do reportingu</translate>
                </filter-checkbox>
              </div>
            </div>
          </section>
          <detail-bottom-buttons
              :module-name="moduleName"
              @submit-form="createEntity"
          ></detail-bottom-buttons>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import message from "@/components/mixins/message"
import SelectBox from "@/components/common/SelectBox"
import TextInput from "@/components/common/TextInput"
import packages from "@/components/views/packages/mixins/packages"
import userSettings from "@/components/mixins/user-settings"
import DetailBottomButtons from "@/components/common/DetailBottomButtons"
import requiredFields from "@/components/mixins/required-fields"
import selectOperator from "@/components/mixins/select-operator-business-model"
import FilterCheckbox from "@/components/common/FilterCheckbox"
import SelectBoxMulti from "@/components/common/SelectBoxMulti"
import OperatorSelect from "@/components/common/OperatorSelect"
import detailActions from "@/components/mixins/detail-actions"

export default {
  name: "PackageNew",
  components: {SelectBoxMulti, FilterCheckbox, TextInput, SelectBox, DetailBottomButtons, OperatorSelect},
  mixins: [detailActions, message, userSettings, requiredFields, packages, selectOperator],
  created: function (PackageService, OperatorService, BusinessModelService) {
    this.entityService = PackageService

    if (this.$_createActionAllowedAllOrOwnAndGlobal) {
      this.operatorService = OperatorService
      this.businessModelService = BusinessModelService
      this.getOperatorsAndBusinessModelsAndSetIdsToEntity(true);
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/packages/PackageNew.vue